<div class="card-body p-3">
  <div class="mb-3">
    <h4>
      {{ cardHeader | translate }}
    </h4>
  </div>
  <div class="mb-3">
    <p class="card-details">
      {{ cardDetail | translate }}
    </p>
  </div>
</div>
